import React, { useState } from "react";

import manualGridImg from "../../../../assets/images/manual.svg";
import knockoutPhaseImg from "../../../../assets/images/knockout.svg";
import groupPhaseImg from "../../../../assets/images/group-phase.svg";
import groupStageKnockoutImg from "../../../../assets/images/group-knockout-phase.svg";
import ClubbieModal from "../../../Modal/ClubbieModal";

const options = [
  {
    id: "manualGrid",
    label: "Manual",
    image: manualGridImg,
  },
  {
    id: "knockoutPhase",
    label: "Cup / Knockout",
    image: knockoutPhaseImg,
  },
  {
    id: "groupPhase",
    label: "League",
    image: groupPhaseImg,
  },
  {
    id: "groupStageKnockout",
    label: "Tournament - Group + Knockout",
    image: groupStageKnockoutImg,
  },
];

const AddPhaseModal = ({ isOpen, onClose, onConfirm }) => {
  const [selected, setSelected] = useState("manualGrid");

  const handleSave = () => {
    onConfirm(selected);
    onClose();
  };

  return (
    <ClubbieModal
      isOpen={isOpen}
      toggle={onClose}
      title="Choose format"
      maxHeight="90vh"
      width="792px"
      footer={(
        <div className="flex justify-end gap-3 w-full">
          <button
            type="button"
            className="px-6 py-3 text-sm font-medium text-app-text bg-app-card rounded-full hover:text-[#FEFCEB] transition-colors"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="bg-[#00E7FF] hover:bg-[#00cce6] text-[#021529] font-medium px-6 py-3 rounded-full text-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleSave}
          >
            Create
          </button>
        </div>
      )}
    >
      <p className="text-[#7F8585] text-sm mb-4">Templates</p>
      <div className="flex flex-wrap gap-5 pb-2">
        {options.map(({ id, label, image }) => {
          const isSelected = selected === id;
          return (
            <label
              key={id}
              htmlFor={id}
              className={`relative flex-[1_1_45%] rounded-[20px] p-3 cursor-pointer select-none border transition-colors ${
                isSelected ? "border-[#00E7FF]" : "border-[#192634]"
              }`}
            >
              <input
                type="radio"
                id={id}
                name="phaseType"
                value={id}
                checked={isSelected}
                onChange={() => setSelected(id)}
                className="hidden"
              />

              {/* Label + Radio row */}
              <div className="flex items-center justify-between mb-4">
                <span className="text-[#B2B5AD] text-sm font-medium">{label}</span>
                <div
                  className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${
                    isSelected ? "border-[#00E7FF]" : "border-[#7F8585]"
                  }`}
                >
                  {isSelected && (
                    <div className="w-2.5 h-2.5 rounded-full bg-[#00E7FF]" />
                  )}
                </div>
              </div>

              <img
                src={image}
                alt={label}
                className="w-full rounded-md pointer-events-none"
              />
            </label>
          );
        })}
      </div>
    </ClubbieModal>
  );
};

export default AddPhaseModal;
